import React, { useEffect, useRef, useState } from 'react'
import { useFormik } from 'formik';
import Cookies from 'js-cookie';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
// import { adminMainUrl } from '../../Config';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { adminMainUrl } from "../../Config.jsx";
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { getCustomerRegData } from '../../Redux/action/Admin/CustomerAction.js';
import Beatloader from '../../Common/Loaders/Beatloader.jsx';



const ApprovalDisapprovalModal = ({ customer_id, show, handleClose, refresh, customer_name }) => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [showLoader, setShowLoader] = useState(true);
    const [showWholeForm, setShowWholeForm] = useState(false);
    const [showRejectionForm, setShowRejectionForm] = useState(false);
    const [imagePreview, setImagePreview] = useState(null);
    const dispatch = useDispatch();
    useEffect(() => {
        if (customer_id) {
            dispatch(getCustomerRegData(customer_id))
        } else {
            setShowLoader(false);
        }
    }, [customer_id]);





    let {
        loadingCustomerRegDataApi,
        CustomerRegDataError,
        CustomerRegData,
    } = useSelector(state => state?.CustomerReducer);

    useEffect(() => {
        if (loadingCustomerRegDataApi) {
            setShowLoader(true);
        } else {
            setShowLoader(false);
        }
    }, [loadingCustomerRegDataApi, CustomerRegDataError, CustomerRegData])

    const closeButtonRef = useRef(null);
    const validationSchema = Yup.object({
        disapprovalReason: Yup.string().required('Disapproval message is required'),
    });

    // Initialize Formik
    const formik = useFormik({
        initialValues: {
            approval: "",
            committed_witness_name: "",
            committed_witness_address: "",
            committed_witness_signature: "",
            rejection_reason: "",
        },
        validationSchema: Yup.object({}),
        onSubmit: async (values, { resetForm }) => {
            values.customer_id = customer_id
            setIsSubmitting(true);
            try {
                axios.post(`${adminMainUrl}/api/customer/approval`,
                    values, // The request payload
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            'auth-token': Cookies.get('token'), // Assuming the token is stored in cookies
                            'user_id': Cookies.get('flexichain_user_id')
                        }
                    }
                ).then(response => {
                    if (response.status === 200) { // Check if the response is OK
                        toast.success(response.data?.msg);
                        handleClose();
                        setIsSubmitting(false);
                        resetForm();
                        formik.setFieldValue("approval", "")
                        formik.setFieldValue("committed_witness_signature", "");
                        setShowWholeForm(false);
                        setShowRejectionForm(false);
                        refresh();
                    } else {
                        toast.error(response.data?.msg);
                    }
                }).catch(error => {
                    setIsSubmitting(false);
                    if (error.response) {
                        toast.error(error.response.data?.msg || "An error occurred.");
                        console.error('Error disapproving document:', error.response.data?.message);
                    } else {
                        toast.error("Network error or server is unreachable.");
                        console.error('Network error:', error);
                    }
                });
            } catch (error) {
                setIsSubmitting(false);
                console.error('Network error:', error);
            }
        },
    });

    const handleAcceptance = (val) => {
        if (val == "APPROVED") {
            formik.setFieldValue("approval", val);
        } else if (val == "DISAPPROVED") {
            formik.setFieldValue("approval", val);
        }
    }


    useEffect(() => {
        if (formik.values.approval) {
            if (formik.values.approval == "APPROVED") { setShowWholeForm(true); setShowRejectionForm(false); }
            if (formik.values.approval == "DISAPPROVED") { setShowWholeForm(true); setShowRejectionForm(true); }
        }
    }, [formik.values.approval])

    return (
        <Offcanvas className="custom-offcanvas" show={show} onHide={handleClose} placement="end">
            {showLoader ?
                <Beatloader />
                :
                <>
                    <Offcanvas.Header closeButton>
                        <Offcanvas.Title>Approve / Reject Request</Offcanvas.Title>
                    </Offcanvas.Header>
                    <Offcanvas.Body>
                        {customer_name && <div className="row d-flex">
                            <div className="col-md-5">
                                <label htmlFor="Customer Name">Customer Name:</label>
                            </div>
                            <div className="col-md-7">
                                <span>{customer_name}</span>
                            </div>
                        </div>}
                        <form onSubmit={formik.handleSubmit}>
                            <div className="mb-3 mt-5">

                                <div className="row">
                                    <div className="col-md-12 text-center">
                                        <button className={`btn w-50 btn-outline-success ${formik.values.approval == "APPROVED" && "active"}`} type='button' onClick={() => handleAcceptance("APPROVED")}>&#x2713; Accept</button>
                                    </div>
                                    <div className="col-md-12 text-center mt-3">
                                        <button className={`btn w-50 btn-outline-danger ${formik.values.approval == "DISAPPROVED" && "active"}`} type='button' onClick={() => handleAcceptance("DISAPPROVED")} style={{ backgroundColor: "red !important" }}>&#10008; Reject</button>
                                    </div>

                                </div>
                                {
                                    showWholeForm ?
                                        (!showRejectionForm) ?
                                            <>
                                                <div className="row">
                                                    <div className="col-md-12 my-2">
                                                        <label htmlFor="committed_witness_name" className='form-label'>Committed Witness Name: <span style={{ color: 'red' }}>*</span></label>
                                                        <input type="text" className="form-control form-control-sm"
                                                            maxLength={250}
                                                            name="committed_witness_name"
                                                            id="committed_witness_name"
                                                            onChange={formik.handleChange}
                                                            value={formik.values.committed_witness_name}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                    </div>
                                                    <div className="col-md-12 my-2">
                                                        <label htmlFor="committed_witness_address" className='form-label'>Committed Witness Address: <span style={{ color: 'red' }}>*</span></label>
                                                        <input type="text" className="form-control form-control-sm"
                                                            maxLength={250}
                                                            name="committed_witness_address"
                                                            id="committed_witness_address"
                                                            onChange={formik.handleChange}
                                                            value={formik.values.committed_witness_address}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                    </div>
                                                    <div className="col-md-12 my-2">
                                                        <label htmlFor="committed_witness_signature" className='form-label'>Committed Witness Signature: <span style={{ color: 'red' }}>*</span></label>
                                                        <input
                                                            type="file"
                                                            className="form-control"
                                                            name="committed_witness_signature"
                                                            id="committed_witness_signature"
                                                            accept='image/*'
                                                            onChange={(event) => {
                                                                const file = event.currentTarget.files[0];

                                                                // Check if the uploaded file is an image
                                                                if (file && !file.type.startsWith("image/")) {
                                                                    toast.error("Please upload a valid image file.");
                                                                    event.target.value = ""; // Clear the file input
                                                                    setImagePreview(null); // Clear preview
                                                                } else if (file.size > 10 * 1024 * 1024) {
                                                                    toast.error("Max allowed file size is 10MB.");
                                                                    event.target.value = ""; // Clear the file input
                                                                    setImagePreview(null);
                                                                    return; // Exit the function if the file is too large
                                                                } else {
                                                                    // Set preview if valid
                                                                    formik.setFieldValue("committed_witness_signature", file);
                                                                    setImagePreview(URL.createObjectURL(file));
                                                                }
                                                            }}
                                                            onBlur={formik.handleBlur}
                                                        />

                                                    </div>
                                                    {imagePreview && (
                                                        <div style={{ marginTop: "20px", textAlign: "center" }}>
                                                            <img src={imagePreview} alt="Preview" style={{ maxWidth: "100%", height: "200px", border: "1px solid black", borderRadius: "5px" }} />
                                                        </div>
                                                    )}
                                                </div>

                                            </>
                                            :
                                            <>
                                                <label htmlFor="name" className="form-label">
                                                    Disapproval Reason <span style={{ color: 'red' }}>*</span>
                                                </label>
                                                <textarea
                                                    maxLength={3000}
                                                    rows={5}
                                                    className="form-control"
                                                    id="rejection_reason"
                                                    name="rejection_reason"
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    value={formik.values.rejection_reason}
                                                ></textarea>
                                            </>
                                        :
                                        null
                                }
                            </div>
                            {showWholeForm && <div className="d-flex justify-content-end">
                                <button className="btn btn-primary text-xs" type="submit" disabled={isSubmitting}>
                                    {isSubmitting ? <i className="fa fa-spinner fa-spin" /> : "Submit"}
                                </button>
                            </div>}

                        </form>
                    </Offcanvas.Body>
                </>
            }

        </Offcanvas>
    )
}

export default ApprovalDisapprovalModal